import React from "react";
import { useNavigate } from "react-router-dom";
import { CommonIcons } from "shared";

import FinanceExecutiveGraphics from "assets/images/default-program-thumbnail.jpg";
import ArrowRightIconWhite from "assets/images/icons/arrow-right-icon-white.svg";
import BadgeCard from "assets/images/icons/Badge_card.png";
import StopWatch from "assets/images/icons/stop-watch.png";

export const ProgramCard = ({
  data,
  onOpenModal,
  setCurrentProgram,
  activateBatchMutation,
  onClickProgram,
  isMWCD = false,
}) => {
  const navigate = useNavigate();
  const {
    id,
    studentBatchId,
    name,
    terms,
    illustrationLogoUrl,
    hasLearningMaterials,
    hasAssessment,
    hasAssignment,
    hasCertificates,
    isAssessmentCompleted,
    isAssignmentCompleted,
    isCertificateCompleted,
    isLearningMaterialsCompleted,
    isActivated,
    requireRegIdVerify,
    isTermAccepted,
    associateName,
    displayDuration,
    hasAttendance,
    isProgramLoading,
    isAttendanceMarked,
  } = data;

  const onButtonClick = () => {
    const data = {
      id,
      studentBatchId,
      name,
      displayDuration,
      hasAttendance,
      isAttendanceMarked,
    };
    const hasAttendanceNotRequiredOrMarked =
      isAttendanceMarked == null ? true : isAttendanceMarked;

    setCurrentProgram((draft) => {
      draft.id = id;
      draft.studentBatchId = studentBatchId;
      draft.name = name;
      draft.displayDuration = displayDuration;
      draft.hasAttendance = hasAttendance;
      draft.isAttendanceMarked = isAttendanceMarked;
      return draft;
    });
    if (
      isActivated &&
      (isTermAccepted || !terms) &&
      hasAttendanceNotRequiredOrMarked
    ) {
      localStorage.setItem("_stu_selectedProgram", JSON.stringify(data));
      navigate(`/program`);
    } else if (!isActivated && requireRegIdVerify) {
      onOpenModal({
        actionFrom: "confirmRegistration",
        info: studentBatchId,
      });
    } else if (!isActivated && !requireRegIdVerify) {
      activateBatchMutation.mutate(
        {
          studentBatchId,
          regNo: null,
        },
        {
          onSuccess: () => {
            if (!isTermAccepted && !!terms) {
              onOpenModal({
                actionFrom: "acceptTerms",
                info: {
                  studentBatchId,
                  terms,
                  hasAttendance,
                  isAttendanceMarked,
                },
              });
            } else if (hasAttendance && !isAttendanceMarked) {
              onClickProgram(data);
            } else {
              navigate(`/program`);
              localStorage.setItem(
                "_stu_selectedProgram",
                JSON.stringify(data)
              );
            }
          },
        }
      );
    } else if (!isTermAccepted && !!terms) {
      onOpenModal({
        actionFrom: "acceptTerms",
        info: { studentBatchId, terms, hasAttendance, isAttendanceMarked },
      });
    } else if (hasAttendance && !isAttendanceMarked) {
      onClickProgram(data);
    }
  };

  return (
    <div
      className="featured-item d-flex flex-column justify-content-between cursor-pointer"
      onClick={onButtonClick}
    >
      <div className="featured-content">
        <div className="item-thumbnail" style={{ backgroundColor: "#fff" }}>
          <img
            className="img-fluid"
            src={
              illustrationLogoUrl
                ? illustrationLogoUrl
                : FinanceExecutiveGraphics
            }
            alt=""
          />
        </div>
        <div className="px-2 py-1">
          <h3 className="text-wrap mb-2 fw-semibold">{name}</h3>
          {!isMWCD && (
            <div className="d-flex align-items-center gap-3 featured-badge">
              {associateName && (
                <div className="d-flex align-items-center gap-2">
                  <img className="badge-icon" src={BadgeCard} alt="badge" />
                  <span className="fw-medium badge-text">{associateName}</span>
                </div>
              )}
              {displayDuration && (
                <>
                  <div className="badge-divider border-end" />
                  <div className="d-flex align-items-center gap-2">
                    {/* <img className="duration-icon" src={StopWatch} alt="duration" /> */}
                    {/* <span className="fw-medium text-dark">2 Week Of Learning</span> */}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
